// src/components/Charts/EntityShareChart.jsx
import React from 'react';
import { Line } from 'react-chartjs-2';
const EntityShareChart = () => {
  const data = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    datasets: [
      {
        label: 'Maersk',
        data: [27.2, 27.5, 27.8, 28.0, 28.2, 28.5, 28.3, 28.4, 28.5, 28.4, 28.5, 28.5],
        borderColor: '#ff6384',
        backgroundColor: 'rgba(255, 99, 132, 0.1)',
        borderWidth: 3,
        tension: 0.4,
        fill: true
      },
      {
        label: 'MSC',
        data: [21.5, 21.8, 22.0, 22.1, 22.2, 22.3, 22.2, 22.3, 22.3, 22.3, 22.3, 22.3],
        borderColor: '#ff9f40',
        backgroundColor: 'rgba(255, 159, 64, 0.1)',
        borderWidth: 3,
        tension: 0.4,
        fill: true
      },
      {
        label: 'CMA CGM',
        data: [18.2, 18.3, 18.4, 18.5, 18.6, 18.7, 18.6, 18.7, 18.7, 18.7, 18.7, 18.7],
        borderColor: '#4cd964',
        backgroundColor: 'rgba(76, 217, 100, 0.1)',
        borderWidth: 3,
        tension: 0.4,
        fill: true
      },
      {
        label: 'COSCO',
        data: [14.5, 14.7, 14.8, 14.9, 15.0, 15.2, 15.1, 15.2, 15.2, 15.2, 15.2, 15.2],
        borderColor: '#9966ff',
        backgroundColor: 'rgba(153, 102, 255, 0.1)',
        borderWidth: 3,
        tension: 0.4,
        fill: true
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      y: {
        beginAtZero: false,
        title: {
          display: true,
          text: 'Market Share %'
        },
        grid: {
          color: 'rgba(0, 0, 0, 0.05)'
        }
      },
      x: {
        grid: {
          color: 'rgba(0, 0, 0, 0.05)'
        }
      }
    },
    plugins: {
      legend: {
        position: 'top',
      }
    }
  };

  return <Line data={data} options={options} />;
};

export default EntityShareChart;